export const checkFirstTimeViewLocalStorage = {
    isFirstTimeView(): boolean {
        return checkFirstTimeViewLocalStorage.getFirstTimeView() !== 'yes';
    },
    getFirstTimeView() {
        return localStorage.getItem('grading.components.header.firstTimeViewLocalStorage');
    },
    setFirstTimeView() {
        localStorage.setItem('grading.components.header.firstTimeViewLocalStorage', 'yes');
    },
};
